module.exports = __webpack_public_path__ + "img/weiyuanLvzhiBg.5665ea73.png";